import moment from 'moment'
import Papa from 'papaparse'
import api from '@/services/api'
import { snakeToCamel } from '../../../utils/object'

export default class ReportAPI {
  static REPORT_ENDPOINT = 'evaluations/reports/'

  /**
   * Initialize a `UserAPI` instance.
   *
   * @param {class} cls  The class to use to create user objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `UserAPI`.
   *
   * @param {class} cls      The class to use to create user objects.
   **/
  static create(cls) {
    return new UserAPI(cls)
  }

  static forceFileDownload(response) {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const disposition = response.headers['content-disposition']

    // I shamelessly stole this from stack overflow. I should clean this up
    var filename = 'file.csv'
    if (disposition && disposition.indexOf('attachment') !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      var matches = filenameRegex.exec(disposition)
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '')
      }
    }
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${moment().format('M-D-YY, h.mm.ss a')} - ${filename}`)
    document.body.appendChild(link)
    link.click()
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  retrieveReports() {
    //console.log("retrieveReports")
    const url = ReportAPI.REPORT_ENDPOINT
    //console.log(url)
    return this.client
      .get(url)
      .then(response => snakeToCamel(response.data))
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log('Retrieve Reports API Error', error)
      })
  }

  retrieveExport(exportUrl) {
    const url = exportUrl
    return this.client
      .get(url)
      .then(response => {
        ReportAPI.forceFileDownload(response)
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
  }
  retrieveExportData(exportUrl) {
    const url = exportUrl
    return this.client
      .get(url)
      .then(response => {
        //console.log("response.data1")
        //console.log(response.data)
        return this.csvJSON(response.data)
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
  }
  csvJSON(csv) {
    const parsed = Papa.parse(csv, {
      header: true,
      skipEmptyLines: true,
      transformHeader: header => header.replace(/ /g, '_'),
    })
    return parsed.data
  }
}
